<template>
  <div>
    <form @submit.prevent="handleSubmit">
      <div class="mb-16">
        <RevInputText
          id="productTitle"
          v-model="values.productTitle"
          :label="i18n(translations.productSearch)"
          type="text"
        />
      </div>

      <div class="md:flex md:align-top">
        <div
          class="mb-16 grid flex-1 grid-cols-4 gap-16 overflow-hidden"
          :class="{ 'max-h-56': !shouldShowAllFilters }"
        >
          <RevInputSelect
            id="categoryId"
            v-model="values.categoryId"
            :label="i18n(translations.categoryId)"
            :options="categoryOptions"
          />

          <RevInputSelect
            id="backboxGrade"
            v-model="values.backboxGrade"
            :label="i18n(translations.grade)"
            :options="gradeOptions"
          />

          <RevInputSelect
            id="currency"
            v-model="values.currency"
            :label="i18n(translations.currency)"
            :options="currencyFilterOptions"
          />

          <RevInputSelect
            id="competitionLevel"
            v-model="values.competitionLevel"
            :label="i18n(translations.competition)"
            :options="competitionOptions"
          />
        </div>

        <div class="ml-16">
          <RevButton type="submit" variant="primary" @click="handleSubmit">
            {{ i18n(translations.applyFilters) }}
          </RevButton>
          <RevLink class="ml-16" type="button" @click="handleReset">
            {{ i18n(translations.resetFilters) }}
          </RevLink>
        </div>
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { type Option, RevInputSelect } from '@ds/components/InputSelect'
import { RevInputText } from '@ds/components/InputText'
import { RevLink } from '@ds/components/Link'

import translations from '../Filters.translations'
import type { FilterValues } from '../Filters.types'
import { getInitialValues } from '../Filters.utils'

const emit = defineEmits(['submit'])
const props = defineProps<{
  initialValues: FilterValues
  gradeOptions: Option[]
  categoryOptions: Option[]
  currencyFilterOptions: Option[]
  competitionOptions: Option[]
}>()

const i18n = useI18n()
const values = ref({ ...props.initialValues })
const shouldShowAllFilters = ref(false)

function handleReset() {
  values.value = getInitialValues()
  emit('submit', values.value)
}
function handleSubmit() {
  emit('submit', values.value)
}
</script>
